import { useState } from 'react'
import { useSelector } from 'react-redux'

import cookies, { ACCEPTED_PRIVACY_POLICY } from 'services/cookies'
import { getPolicyBannerStrings } from 'store/strings/selectors'
import PolicyBanner from 'ui-component-library/components/PolicyBanner'

function PolicyBannerContainer() {
  const [hasAccepted, setAccepted] = useState(
    Boolean(cookies.get(ACCEPTED_PRIVACY_POLICY)),
  )
  const { bodyText, acceptButtonText } = useSelector(getPolicyBannerStrings)

  function handleAccept() {
    cookies.save(ACCEPTED_PRIVACY_POLICY, 'true', {
      expires: 365 * 10,
      secure: true,
    })
    setAccepted(true)
  }

  if (hasAccepted) {
    return null
  }

  return (
    <PolicyBanner
      bodyText={bodyText}
      acceptButtonText={acceptButtonText}
      onAccept={handleAccept}
    />
  )
}

export default PolicyBannerContainer
